import { memo } from 'react';
import cn from 'bem-cn';

import { Skeleton, Stack } from '../UI';

import { PromptInfoStatisticsSkeleton } from './PromptInfoStatistics';
import { PromptInfoHeaderSkeleton } from './PromptInfoHeader';
import { PromptInfoBodySkeleton } from './PromptInfoBody';
import { PromptInfoAuthorSkeleton } from './PromptInfoAuthor';
import './PromptInfo.scss';

const b = cn('prompt-info');

export const PromptInfoSkeleton = memo(() => {
    return (
        <Stack spacing={8} className={b()} aria-busy="true" role="status">
            <PromptInfoHeaderSkeleton />
            <PromptInfoStatisticsSkeleton />
            <PromptInfoBodySkeleton />
            <PromptInfoAuthorSkeleton />
            <Stack alignItems="center">
                <Skeleton width="50%" />
            </Stack>
        </Stack>
    );
});
